import React, { FC, useMemo } from 'react';
import { UserReferenceModel } from '../../shared/user/base';
import { renderName } from '../utils';
import { ElementSelector, SearchProvider } from './ElementSelector';
import { ElementSelectorProps } from '.';

type UserSelectorProps = Partial<ElementSelectorProps<UserReferenceModel>>;

const displayFormat = (u: UserReferenceModel) =>
  // Use || for not catching empty strings
  `#${u.id} - ${renderName(u)}`;

export const UserSelector: FC<UserSelectorProps> = (props) => {
  const searchProvider: SearchProvider<UserReferenceModel> = useMemo(
    () => ({
      ids: async (ids) => {
        return (await api.getUsersByIds(ids)).users;
      },
      text: async (txt) => {
        const result = await api.searchUsers(txt);
        return result.users;
      },
    }),
    [],
  );

  return (
    <ElementSelector<UserReferenceModel>
      {...props}
      displayFormat={displayFormat}
      searchProvider={searchProvider}
    />
  );
};
